/**
 *  RaceCamera
 *
 *  Created by Legman on 21/03/2017.
 *
 */

import Point4 from "./Point4";
import RaceEntity from "./RaceEntity";

/**
 * @class
 * @memberOf race
 */
export default class RaceCamera {
    /**
     * @param {Point4} [position]
     * @param {!number} [angle=0]
     */
    constructor(position, angle = 0) {
        /**
         * @member {RaceEntity}
         */
        this.target = null;

        /**
         * @member {Point4}
         */
        this.position = position || new Point4();

        /**
         * @member {number}
         * @default 0
         */
        this.angle = angle;

        /**
         * @member {PIXI.Point}
         */
        this.vanishingPoint = new PIXI.Point();

        /**
         * @member {number}
         * @default 90
         */
        this.fieldOfView = 90;

        /**
         * @member {number}
         * @default 2.5
         */
        this.focus = 2.5;

        /**
         * @member {number}
         * @default 30
         */
        this.zoom = 30;

        /**
         * @member {number}
         * @default -2
         */
        this.height = -2;

        /**
         * @member {PIXI.Point}
         */
        this.offset = new PIXI.Point();

        /**
         * @member {number}
         * @default 1
         */
        this.distance = 2;

        /**
         * @member {number}
         * @default 1.6
         */
        this.tilt = 1.6;

        /**
         * @member {number}
         * @default 0.03
         */
        this.tiltEase = 0.01;

        /**
         * @member {PIXI.Point}
         */
        this.shake = new PIXI.Point();

        /**
         * @member {PIXI.Point}
         */
        this.shakeOffset = new PIXI.Point();

        /**
         * @member {number}
         * @default 0.14
         */
        this.shakeEase = 0.14;

        /**
         * @member {number}
         * @default 14
         */
        this.shakeMagnitiude = 14;

        /**
         * @member {number}
         */
        this.shakeElapsed = 0;

        /**
         * @member {number}
         */
        this.shakeDuration = 0;
    }

    /**
     * @param {!number} [duration=1]
     * @param {!number} [magnitude=14]
     */
    applyShake(duration = 1, magnitude = 14) {
        this.shakeDuration = duration;
        this.shakeMagnitiude = magnitude;
        this.shakeElapsed = 0;
    }
}
